export default {
  '_b._qhyy': 'Cambiar idioma',

  '_a._jzz': 'Cargando...',
  '_a._jzgd': 'Cargar más',
  '_a._wct': 'Bienvenido a',
  '_a._gd': 'Más',
  '_a._bf': 'Reproducir',
  '_a._bcz': 'Guardando...',
  '_a._sctp': 'Subir imagen',

  '_dl._qssyx': 'Por favor ingrese su correo electrónico',
  '_dl._qssmm': 'Por favor ingrese su contraseña',
  '_dl._ann': 'Iniciar sesión',
  '_dl._hmyzh': '¿No tienes una cuenta?',
  '_dl._qzc': 'Registrarse',
  '_dl._yzhl': '¿Ya tienes una cuenta?',
  '_dl._qdl': 'Iniciar sesión',
  '_dl._srqrmm': 'Por favor confirme su contraseña',
  '_dl._sryqm': 'Por favor ingrese el código de invitación',
  '_dl._sryzm': 'Por favor ingrese el código de verificación',
  '_dl._ljzc': 'Registrarse ahora',
  '_dl._zcbsty': 'Al registrarse acepta haber leído y estar de acuerdo con la',
  '_dl._yszc': 'Política de Privacidad',
  '_dl._lcmmbyy': 'Las contraseñas no coinciden',

  '_yzm._fsyzm': 'Enviar código de verificación',
  '_yzm._cxfs': '({time}) Reenviar',
  '_yzm._fsz': 'Enviando...',
  '_yzm._fscg': 'Enviado exitosamente',

  '_h._zrm': 'Más popular',
  '_h._zxd': 'Más reciente',
  '_h._phb': 'Ranking',
  '_h._qz': 'Fondos de pantalla',
  '_h._ssww': 'Buscar',
  '_h._lsjl': 'Historial',
  '_h._gd': 'Más',
  '_h._dl': 'Iniciar sesión',
  '_h._ye': 'Saldo',
  '_h._dj': 'Congelado',
  '_h._ybp': 'Panel de control',
  '_h._wdqb': 'Mi billetera',
  '_h._scjl': 'Favoritos',
  '_h._xxzx': 'Centro de mensajes',
  '_h._fxhy': 'Compartir con amigos',
  '_h._bzzx': 'Centro de ayuda',
  '_h._ggtf': 'Colocación de publicidad',
  '_h._bqtz': 'Inversión en derechos de autor',
  '_h._sz': 'Configuración',

  '_sy._jx': 'Destacados',
  '_sy._xpfb': 'Nuevos lanzamientos',
  '_sy._gdsp': 'Más videos',

  '_qz._jbqz': 'Colección de fondos de pantalla exquisitos',
  '_qz._ssqz': 'Buscar fondo de pantalla',
  '_qz._qb': 'Todos',
  '_qz._zrfg': 'Paisajes naturales',
  '_qz._cxys': 'Arte abstracto',
  '_qz._csjz': 'Arquitectura urbana',
  '_qz._dmyx': 'Anime y juegos',
  '_qz._yzxk': 'Cosmos y estrellas',
  '_qz._yl': 'Vista previa',
  '_qz._xzqz': 'Descargar fondo de pantalla',
  '_qz._fbl': 'Resolución',
  '_qz._fl': 'Categoría',
  '_qz._jzz': 'Cargando',
  '_qz._myzdpp': 'No se encontraron fondos de pantalla que coincidan',

  '_sp._xyjscl': 'Se requiere desbloqueo para ver',
  '_sp._cz': 'Recargar',
  '_sp._jsqj': 'Desbloquear todos los episodios',
  '_sp._jsbj': 'Desbloquear este episodio',
  '_sp._sc': 'Favorito',
  '_sp._fx': 'Compartir',
  '_sp._jsqjjs': '¿Confirmar pago de {a} para desbloquear todos los episodios?',
  '_sp._jsbjjs': '¿Confirmar pago de {a} para desbloquear este episodio?',
  '_sp._zfz': 'Procesando pago...',
  '_sp._qrzf': 'Confirmar pago',
  '_sp._qx': 'Cancelar',

  '_qz._smrc': 'Amanecer en la montaña',
  '_qz._cxjh': 'Geometría abstracta',
  '_qz._dsyj': 'Paisaje nocturno urbano',
  '_qz._dmfj': 'Paisaje anime',
  '_qz._hhxk': 'Cielo estrellado vasto',
  '_qz._slmw': 'Niebla del bosque',
  '_qz._scld': 'Flujo de color',
  '_qz._xdjz': 'Arquitectura moderna',

  '_qb._cbjl': 'Historial de depósitos',
  '_qb._jyjl': 'Historial de transacciones',
  '_qb._bddz': 'Direcciones vinculadas',
  '_qb._txjl': 'Historial de retiros',

  '_m._tcdl': 'Cerrar sesión',
  '_m._cb': 'Depositar',
  '_m._tb': 'Retirar',

  '_cb._ssdz': 'Buscar moneda o dirección',
  '_cb._bz': 'Moneda',
  '_cb._je': 'Cantidad',
  '_cb._dz': 'Dirección',
  '_cb._sj': 'Tiempo',
  '_cb._cz': 'Acción',
  '_cb._zwjl': 'Aún no hay registros de transacciones',
  '_cb._dny': 'Página {a} de {b}',
  '_cb._jyxq': 'Detalles de la transacción',
  '_cb._jydz': 'Dirección de la transacción',
  '_cb._zt': 'Estado',
  '_cb._yqr': 'Confirmado',
  '_cb._qb': 'Todos',
  '_cb._jt': 'Hoy',
  '_cb._j7t': 'Últimos 7 días',
  '_cb._j30t': 'Últimos 30 días',
  '_cb._zw': 'Ninguno',
  '_cb._fzcg': 'Dirección copiada al portapapeles',

  '_jyjl._ssdz': 'Buscar moneda o dirección',
  '_jyjl._lx': 'Tipo',
  '_jyjl._je': 'Cantidad',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Congelado',
  '_jyjl._sj': 'Tiempo',
  '_jyjl._cz': 'Acción',
  '_jyjl._zwjyjl': 'Aún no hay registros de transacciones',
  '_jyjl._czsx': 'Restablecer filtro',
  '_jyjl._dny': 'Página {a} de {b}',
  '_jyjl._jyxq': 'Detalles de la transacción',
  '_jyjl._jylx': 'Tipo de transacción',
  '_jyjl._jyje': 'Monto de la transacción',
  '_jyjl._jyhye': 'Saldo después de la transacción',
  '_jyjl._djye': 'Monto congelado',
  '_jyjl._jysj': 'Hora de la transacción',
  '_jyjl._jyzt': 'Estado de la transacción',
  '_jyjl._ywc': 'Completado',
  '_jyjl._qb': 'Todos',
  '_jyjl._jt': 'Hoy',
  '_jyjl._j7t': 'Últimos 7 días',
  '_jyjl._j30t': 'Últimos 30 días',

  '_jyjl._tp1': 'Depósito',
  '_jyjl._tp2': 'Retiro',
  '_jyjl._tp3': 'Pago',
  '_jyjl._tp4': 'Depósito',
  '_jyjl._tp5': 'Congelar',
  '_jyjl._tp6': 'Ganancias',
  '_jyjl._tp7': 'Recompensa por referir',
  '_jyjl._tp8': 'Recompensa por iniciar sesión',
  '_jyjl._tp9': 'Ganancias por promoción',
  '_jyjl._tp10': 'Recompensa por ver video',
  '_jyjl._tp11': 'Bono de registro',
  '_jyjl._tp12': 'Retiro rechazado',
  '_jyjl._tp13': 'Mensaje de paquete rojo',

  '_jyjl._tp14': 'Transferencia interna',

  '_cb._shz': 'En revisión',
  '_cb._yyg': 'Aprobado',
  '_cb._ybh': 'Rechazado',

  '_bddz._tjdz': 'Agregar dirección',
  '_bddz._ssdz': 'Buscar dirección',
  '_bddz._bz': 'Moneda',
  '_bddz._dz': 'Dirección',
  '_bddz._sysj': 'Último uso',
  '_bddz._cz': 'Acción',
  '_bddz._zwjl': 'Aún no hay registros de direcciones',
  '_bddz._dny': 'Página {a} de {b}',
  '_bddz._dzewm': 'Código QR de la dirección',
  '_bddz._fzdz': 'Copiar dirección',
  '_bddz._dzxq': 'Detalles de la dirección',
  '_bddz._wl': 'Red',
  '_bddz._tjsj': 'Fecha de agregado',
  '_bddz._bzwa': 'Nota',
  '_bddz._ntq': 'Hace {a} días',
  '_bddz._nxsq': 'Hace {a} horas',
  '_bddz._nfzq': 'Hace {a} minutos',
  '_bddz._ngg': 'Ahora mismo',
  '_bddz._dzyfz': 'Dirección copiada al portapapeles',
  '_bddz._scqr': 'Confirmar eliminación',
  '_bddz._scqrdz': '¿Está seguro de que desea eliminar esta dirección?',
  '_bddz._qr': 'Confirmar',
  '_bddz._qx': 'Cancelar',
  '_bddz._scdzcg': 'Dirección eliminada exitosamente',

  '_txjl._ztsx': 'Filtro por estado',
  '_txjl._qbzt': 'Todos los estados',
  '_txjl._shz': 'En revisión',
  '_txjl._ytg': 'Aprobado',
  '_txjl._yjj': 'Rechazado',
  '_txjl._ssdz': 'Buscar dirección o monto',
  '_txjl._bz': 'Moneda',
  '_txjl._je': 'Cantidad',
  '_txjl._dz': 'Dirección',
  '_txjl._zt': 'Estado',
  '_txjl._sj': 'Tiempo',
  '_txjl._cz': 'Acción',
  '_txjl._zwjl': 'Aún no hay registros de transacciones',
  '_txjl._czsx': 'Restablecer filtro',
  '_txjl._dny': 'Página {a} de {b}',
  '_txjl._jyxq': 'Detalles de la transacción',
  '_txjl._skdz': 'Dirección de recepción',
  '_txjl._jysj': 'Hora de la transacción',
  '_txjl._jyzt': 'Estado de la transacción',
  '_txjl._fzdz': 'Dirección copiada al portapapeles',

  '_cbsq._bz': 'Moneda',
  '_cbsq._wl': 'Red',
  '_cbsq._erwm': 'Código QR',
  '_cbsq._fzdz': 'Copiar dirección',

  '_txsq._bz': 'Moneda',
  '_txsq._wl': 'Red',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Tarifa',
  '_txsq._zxtx': 'Retiro mínimo',
  '_txsq._txdz': 'Dirección de retiro',
  '_txsq._qxztxdz': 'Por favor seleccione la dirección de retiro',
  '_txsq._txje': 'Monto a retirar',
  '_txsq._qsrtxje': 'Por favor ingrese el monto a retirar',
  '_txsq._yxyzm': 'Código de verificación de correo',
  '_txsq._qsryxyzm': 'Por favor ingrese el código de verificación',
  '_txsq._ljtx': 'Retirar ahora',

  '_jl._wxhd': 'Mis me gusta',
  '_jl._lsjl': 'Historial',

  '_xx._bt': 'Centro de mensajes',
  '_xx._wjl': 'Sin registros',
  '_xx._zsmyxx': 'Aún no hay mensajes',
  '_xx._sxxx': 'Actualizar mensajes',
  '_xx._sxcg': 'Actualizado exitosamente',

  '_fx._fxhy': 'Compartir con amigos',
  '_fx._smfx': 'Escanee el código QR para compartir con amigos',
  '_fx._jlsm': 'Descripción de la recompensa',
  '_fx._jlsm1': '1. Los amigos que invites directamente (Nivel 1) te otorgarán el {a}% de sus ganancias.',
  '_fx._jlsm2': '2. Los amigos invitados por tus amigos de Nivel 1 (Nivel 2) te otorgarán el {a}% de sus ganancias.',
  '_fx._jlsm3': '3. Los amigos invitados por tus amigos de Nivel 2 (Nivel 3) te otorgarán el {a}% de sus ganancias.',
  '_fx._fzlj': 'Copiar enlace',

  '_bzzx._bzzx': 'Centro de ayuda',
  '_bzzx._rhzczh': 'Cómo registrar una cuenta',
  '_bzzx._zclc': 'Proceso de registro',
  '_bzzx._rhzcxyh': '¿Cómo registrar una nueva cuenta?',
  '_bzzx._rhzcxyh1': 'Haga clic en el botón "Registrarse", ingrese su dirección de correo electrónico, establezca una contraseña y complete la verificación de correo electrónico para registrar una cuenta exitosamente.',
  '_bzzx._rhcz': '¿Cómo recargar?',
  '_bzzx._rhcz1': 'Proceso de recarga',
  '_bzzx._rhcz2': 'Instrucciones detalladas de recarga',
  '_bzzx._rhcz3': 'Haga clic en Mi Billetera, Depositar, seleccione la criptomoneda que desea depositar y envíe a la dirección proporcionada.',

  '_bzzx._rhjsdj': 'Cómo desbloquear drama corto',
  '_bzzx._rhjsdj2': 'Haga clic para desbloquear episodios individuales y ver más contenido emocionante.',

  '_bzzx._rhtx': 'Cómo retirar de la cuenta',
  '_bzzx._rhtx1': '1. Vaya a Mi Billetera, Direcciones de retiro, agregue una nueva dirección de retiro para la criptomoneda correspondiente.<br>2. Haga clic en Retirar, seleccione la criptomoneda, elija una dirección vinculada, ingrese el monto del retiro y espere a que llegue.',

  '_bzzx._qtwt': 'Otras preguntas',
  '_bzzx._qtwt1': '¿Cómo contactar al servicio al cliente?',
  '_bzzx._qtwt2': 'Puede contactarnos a través del servicio al cliente en línea en la esquina inferior derecha del sitio web, correo electrónico o línea directa.',
  '_bzzx._myzdwt': '¿No encontró la respuesta que buscaba?',
  '_bzzx._khjybbzn': 'Nuestro equipo de servicio al cliente está encantado de brindarle más ayuda.',
  '_bzzx._lxkf': 'Contactar servicio al cliente',

  '_ggtf._bt1': 'Colocación de publicidad',
  '_ggtf._splb': 'Lista de videos',
  '_ggtf._wcyd': 'Mi participación',
  '_ggtf._hdbm': 'Código del evento',
  '_ggtf._tian': 'Días',
  '_ggtf._kssj': 'Hora de inicio',
  '_ggtf._jssj': 'Hora de finalización',
  '_ggtf._ddvp': 'Alcance Nivel VIP {a}, promedio {b} participaciones por persona',
  '_ggtf._hdzt': 'Estado del evento',
  '_ggtf._wks': 'No comenzado',
  '_ggtf._ycy': 'Participado',
  '_ggtf._qg': 'Comprar ahora',
  '_ggtf._mygdl': 'No hay más datos',
  '_ggtf._qgrtd': 'Demasiados compradores, por favor intente nuevamente',
  '_ggtf._hdxq': 'Detalles del evento',
  '_ggtf._hdjs': 'Descripción del evento',
  '_ggtf._cyyq': 'Requisitos de participación',
  '_ggtf._zdtz': 'Inversión mínima',
  '_ggtf._vpdj': 'Nivel VIP',
  '_ggtf._rjcy': 'Participación promedio',
  '_ggtf._gmje': 'Monto de compra',
  '_ggtf._qsrgmje': 'Por favor ingrese el monto de compra',
  '_ggtf._qx': 'Cancelar',
  '_ggtf._ljcy': 'Participar ahora',
  '_ggtf._ssjymm': 'Ingrese contraseña de transacción',
  '_ggtf._qssjymm': 'Por favor ingrese la contraseña de transacción',
  '_ggtf._ji': 'Nivel',
  '_ggtf._ci': 'veces',
  '_ggtf._zdgm': 'Monto mínimo de compra',
  '_ggtf._zggm': 'Monto máximo de compra',
  '_ggtf._zfz': 'Procesando pago...',

  '_wdtg._wjl': 'Aún no hay registros de participación',
  '_wdtg._tzje': 'Monto de inversión',
  '_wdtg._zsy': 'Ganancias totales',
  '_wdtg._hdts': 'Días del evento',
  '_wdtg._cysj': 'Hora de participación',
  '_wdtg._qzf': 'Ir a pagar',
  '_wdtg._jxz': 'En progreso',
  '_wdtg._djszje': 'Total pendiente de liquidación',
  '_wdtg._gjb': 'Total de {a} elementos',
  '_wdtg._djs': 'Pendiente de liquidación',
  '_wdtg._zrsy': 'Ganancias de ayer',
  '_wdtg._dbl': 'Reproducciones bajo demanda',
  '_wdtg._bfl': 'Conteo de reproducciones',
  '_wdtg._wdsy': 'Mis ganancias',
  '_wdtg._bqffc': 'Participación del titular de derechos',
  '_wdtg._mr0djs': 'Liquidar las ganancias de ayer diariamente a las 0:00',
  '_wdtg._jrsy': 'Ganancias de hoy',
  '_wdtg._mygd': 'No hay más datos',

  '_bqyy._bqyy': 'Cita para cooperación de derechos de autor',
  '_bqyy._qrbq': '¿Confirmar solicitud de cita para cooperación de derechos de autor?',
  '_bqyy._qx': 'Cancelar',
  '_bqyy._tjyy': 'Enviar cita',

  '_bqyy._spsq': 'Solicitud de cooperación de derechos de autor de video',
  '_bqyy._spsy': '¡Promociona videos junto con los titulares de derechos para traer más tráfico y más ganancias!',
  '_bqyy._ljyy': 'Reservar ahora',
  '_bqyy._sphz': '¿Qué es la Solicitud de Cooperación de Derechos de Autor de Video?',
  '_bqyy._sphzsm': 'La Solicitud de Cooperación de Derechos de Autor de Video proporciona más oportunidades de promoción para beneficio mutuo. A través de la solicitud, obtendrá el reconocimiento de los titulares de derechos y tendrá la oportunidad de una cooperación profunda, obteniendo más exposición y ganancias.',
  '_bqyy._sqhch': 'Beneficios de la Cooperación de Derechos de Autor',
  '_bqyy._llfz': 'Soporte de tráfico',
  '_bqyy._llfzsm': 'Obtenga oportunidades de promoción en la plataforma para aumentar la exposición y el conteo de reproducciones.',
  '_bqyy._sytg': 'Mayores ganancias',
  '_bqyy._sytgsm': 'Obtenga una mayor participación en los ingresos publicitarios y oportunidades de cooperación comercial.',
  '_bqyy._yxhz': 'Cooperación prioritaria',
  '_bqyy._yxhzsm': 'Participación prioritaria en eventos oficiales de la plataforma y proyectos de cooperación comercial.',
  '_bqyy._yytj': 'Condiciones de la cita',
  '_bqyy._sptg': 'Requisitos de promoción publicitaria de video',
  '_bqyy._sptgsm': 'Participe en al menos 1 promoción de video que cumpla con los estándares de la plataforma.',
  '_bqyy._yysm': 'Después de hacer clic en Reservar, nuestro personal se contactará con usted dentro de 3 días laborables.',

  '_ybp._wdsy': 'Mis ganancias',
  '_ybp._dqye': 'Saldo actual',
  '_ybp._jr': 'Hoy',
  '_ybp._jrzsy': 'Ganancias totales de hoy',
  '_ybp._ljzsy': 'Ganancias acumuladas totales',
  '_ybp._tgfh': 'Dividendos por promoción',
  '_ybp._ljsy': 'Ganancias acumuladas',
  '_ybp._bqsy': 'Ganancias por derechos de autor',
  '_ybp._yqfh': 'Dividendos por referidos',
  '_ybp._mrsy': 'Ganancias diarias',
  '_ybp._tgsy': 'Ganancias por promoción',

  '_tjdz._tjxd': 'Agregar nueva dirección',
  '_tjdz._xzbz': 'Seleccionar moneda',
  '_tjdz._qbdz': 'Dirección de la billetera',
  '_tjdz._srdz': 'Por favor ingrese la dirección de la billetera',
  '_tjdz._qx': 'Cancelar',
  '_tjdz._bc': 'Guardar',

  '_sz._smrz': 'Verificación de identidad real',
  '_sz._rzlx': 'Tipo de verificación',
  '_sz._sfzzm': 'Frente del DNI',
  '_sz._sfzfm': 'Reverso del DNI',
  '_sz._zsxm': 'Nombre real',
  '_sz._qsrzsxm': 'Por favor ingrese su nombre real',
  '_sz._sfzhm': 'Número de DNI',
  '_sz._qsrsfzhm': 'Por favor ingrese su número de DNI',
  '_sz._yyzz': 'Licencia comercial',
  '_sz._qymc': 'Nombre de la empresa',
  '_sz._yyzzh': 'Número de licencia comercial',
  '_sz._qsrqymc': 'Por favor ingrese el nombre de la empresa',
  '_sz._qsryyzzh': 'Por favor ingrese el número de licencia comercial',
  '_sz._qx': 'Cancelar',
  '_sz._tjrz': 'Enviar verificación',
  '_sz._zt': 'Estado',
  '_sz._gr': 'Individual',
  '_sz._qy': 'Empresa',
  '_sz._shz': 'En revisión',
  '_sz._ytg': 'Aprobado',
  '_sz._ybh': 'Rechazado',

  '_mm._xgmm': 'Cambiar contraseña',
  '_mm._dqxg': 'Cambie la contraseña regularmente para proteger la seguridad de la cuenta',
  '_mm._dqmm': 'Contraseña actual',
  '_mm._xmm': 'Nueva contraseña',
  '_mm._qrxmm': 'Confirmar nueva contraseña',
  '_mm._qx': 'Cancelar',
  '_mm._qrxg': 'Confirmar cambio',

  '_jymm._xgjymm': 'Cambiar contraseña de transacción',

  '_szzx._sz': 'Configuración',
  '_szzx._yrz': 'Verificado',
  '_szzx._wrz': 'No verificado',
  '_szzx._jymm': 'Contraseña de transacción',
  '_szzx._szjymm': 'Establecer o cambiar contraseña de transacción',
  '_szzx._tcdl': 'Cerrar sesión',
  '_szzx._qdtcdl': '¿Está seguro de que desea cerrar sesión?',
  '_szzx._qrtc': 'Confirmar cierre de sesión',
  '_szzx._qx': 'Cancelar',

  '_yj._gy': 'Acerca de',

  '_yj._lxwm': 'Contáctanos',

  '_yj._yszc': 'Política de Privacidad',

  '_yj._yhxy': 'Acuerdo de Usuario',

  '_cd._gszz': 'Certificaciones de la Empresa',

  '_cd._wmyy': 'Contamos con todas las certificaciones y cualificaciones de la industria, lo que nos permite ofrecer servicios de video legales, seguros y de alta calidad',

  '_cd._yyzz': 'Comprobante válido de la legalidad de la empresa, que demuestre nuestra información de registro formal y alcance comercial',

  '_cd._yyzz2': 'Licencia comercial legalmente obtenida y certificada por la empresa, que garantiza la legalidad y el cumplimiento de la plataforma',

  '_bz._lxkf': 'Haz clic a continuación para contactar con atención al cliente o contáctanos por correo electrónico o línea directa de atención al cliente',

  '_sz._bjtx': 'Editar',

  '_sz._bjxx': 'Editar mensaje',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Guardar',

  '_db._zskf': 'Contactar con Soporte',
  '_db._zsry': 'Agente Especializado',
  '_db._wdq': 'No leído',
  '_db._ydq': 'Leído',

  '_sc._sctp': 'Subir imagen',
  '_sc._xztp': 'Elegir imagen',
  '_sc._fstp': 'Enviar imagen',
  '_sc._qx': 'Cancelar',
  '_sc._hd': 'De acuerdo',

  '_zcyl._zcbt': 'Regalo por registro',
  '_zcyl._djdkhb': 'Toca para abrir el sobre rojo',
  '_zcyl._zclj': 'Premio por registro',
  '_zcyl._hmyzh': '¿No tienes cuenta?',
  '_zcyl._qzc': 'Registrarse',
  '_zcyl._qxdjhb': 'Reclama tu premio primero',
  '_zcyl._qwzc': 'Ir a registro',
  '_zcyl._hbysy': 'Premio ya utilizado',

  '_ggtg._qhz': 'Ir a Transferir',
  '_ggtg._dqye': 'Saldo Actual',
  '_ggtg._qcz': 'Ir a Recargar',
  '_ggtg._hzje': 'Monto de Transferencia',
  '_ggtg._ljhz': 'Transferir Ahora',
  '_ggtg._yebz': 'Saldo Insuficiente',

  '_sq._bhbt': 'Rechazado',

  '_sq._bhyy': 'Motivo del rechazo',

  '_xx._ntq': 'Hace {n} días',

  '_xx._nxsq': 'Hace {n} horas',

  '_xx._nfzq': 'Hace {n} minutos',

  '_xx._nggq': 'Justo ahora',

  '_xx._djckgd': 'Haga clic para ver más',

  '_ct._zt': 'Estado',

  '_ct._ljz': 'Conectando',

  '_ct._ylj': 'Conectado',

  '_ct._ltlieb': 'Lista de chat',

  '_ct._bnhzj': 'No puedo chatear conmigo mismo',

  '_ct._cylb': 'Lista de miembros',

  '_hb._fhb': 'Sobre rojo',

  '_hb._dqye': 'Saldo actual',

  '_hb._fsd': 'Enviado a',

  '_hb._hbje': 'Importe del sobre rojo',

  '_hb._qshuru': 'Ingrese el importe del sobre rojo',

  '_hb._ljfs': 'Enviar ahora',

  '_hb._hbz': "Rojo'Bendición del sobre",
  '_hb._qshuruzhu': 'Por favor, introduzca su bendición',

  '_sp._cuow': 'Los episodios 1-10 deben desbloquearse antes de poder verlos',

  '_bq._tzzq': 'Periodo de inversión',

  '_bq._zrsy': 'Ganancia de ayer',

  '_bq._bqtz': 'Inversión en derechos de autor',

  '_bq._tzdj': 'Importe de la inversión',

  '_bq._zfjz': 'El pago debe realizarse en 24 horas; de lo contrario, se considerará una renuncia',

  '_bq._qzf': 'Realizar pago',

  '_bq.jz': 'Fecha límite',

  '_bq._ljzf': 'Pagar ahora',

  '_bq._sqbz': 'Notas de la solicitud (opcional)',

  '_bq._sqbzsm': 'Introduzca las notas de la solicitud',

  '_bq._zzsqz': "Solicitud de derechos de autor' En curso, pendiente de revisión..",

  '_app._xz': 'Descarga la aplicación ReelShortBiz',

  '_app._smerm': 'Escanea el código QR para descargarla',

  '_app._xzbt': 'Descargar',

  '_m._yhzz': 'Transferencia bancaria',
  '_m._yhxx': 'Información bancaria',
  '_m._yhmz': 'Nombre del banco',
  '_m._yhdz': 'Dirección del banco',
  '_m._yhmc': 'Nombre',
  '_m._yhzh': 'Cuenta',
  '_m._yhlx': 'Tipo',
  '_m._yhly': 'Enrutamiento',
  '_m._yhdm': 'Código',
  '_m._yhbz': 'Nota',
  '_m._fzxx': 'Copiar información',

  '_m._zts': 'Consejos',

  '_m._zyd1': '1. Verifique cuidadosamente el nombre del destinatario, el número de cuenta y el código bancario al transferir fondos. Cualquier error puede resultar en la pérdida de la remesa.',
  '_m._zyd2': "2. Se recomienda seleccionar 'El remitente cubre todos los gastos' para evitar fondos insuficientes debido a las deducciones de los bancos intermediarios.",
  '_m._zyd3': '3. Las transferencias suelen tardar de 1 a 3 días hábiles. Por favor, tenga paciencia. Si tiene alguna pregunta, comuníquese con el servicio de atención al cliente.',
  '_m._zyd4': '4. Si tiene alguna otra pregunta, comuníquese con el servicio de atención al cliente.',
  '_m._jyh': 'Número de transacción',
  '_m._jyje': 'Importe',

  '_sp._dbye': 'Saldo VOD',
  '_sp.hzye': 'Transferencia',
  '_sp._txje': 'Monto de transferencia',
  '_sp._qsrtxje': 'Por favor, ingrese el monto de transferencia',
  '_sp._ljhz': 'Transferir ahora',
  '_sp._yebz': 'Saldo insuficiente',
  '_sp._qshuru': 'Por favor, ingrese el monto correcto de transferencia',
  '_sp._fanh': 'Volver',

  '_sp._tliu': 'Publicidad',
  '_sp._xzgj': 'Seleccionar país',
  '_sp._cdcw': 'Error de codificación de video',
  '_ggtf._hot': 'Tendencia',
  '_tl._tlsj': 'Hora de publicidad',
  '_tl._xzxb': 'Seleccionar género',
  '_tl._nan': 'Hombre',
  '_tl._nv': 'Mujer',
  '_tl._hunhe': 'Mixto',
  '_tl._xznl': 'Seleccionar edad',
  '_sp._us': 'Estados Unidos',
  '_sp._en': 'Reino Unido',
  '_sp._jp': 'Japón',
  '_sp._fr': 'Francia',
  '_sp._kr': 'Corea del Sur',
  '_sp._de': 'Alemania',
  '_sp._id': 'India',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Australia',
  '_sp._es': 'España',
  '_sp._my': 'Malasia',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Volver',
  '_ggtf._jymmts': 'Confirme el monto de la transacción e ingrese su contraseña',
  '_wdtg._wjl_desc': 'Aún no has participado en ninguna campaña publicitaria',
  '_wd._jxz': 'En progreso',
  '_wd._djs': 'Pendiente de liquidación',
  '_wd._ywc': 'Completado',
  '_wd._jz': 'Urgente',
  '_wd._hz': 'Transferencia',

  '_tl._tlfbqk': 'Distribución del gasto publicitario',
  '_tl._tlfbqk_desc': 'Días 1-5: 5% (Fase de inicio en frío), Días 6-10: 20% (Fase de validación de contenido), Días 11-15: 40% (Fase de construcción de IP), Días 16-20: 35% (Fase de matriz de miniseries)',

  '_nhz._sm': 'Después de la transferencia, el monto se transferirá a la billetera de video para desbloquear contenido de video',
  '_nhz._zhzz': 'Transfiriendo...',
  '_nhz._zzcg': 'Transferencia exitosa',
  '_nhz._zhzsb': 'Transferencia fallida, intente nuevamente',
  '_m._fzcg': 'Copiado exitosamente',
  '_m._fzsb': 'Error al copiar, copie manualmente',
  '_m._zwfzxx': 'No hay información para copiar',
  '_tx._qb': 'Todos',
  'activity.detail': 'Detalles de la Actividad',
  'activity.noDesc': 'Sin descripción de la actividad',
  'activity.desc': 'Descripción de la Actividad',
  'activity.requirements': 'Requisitos de Participación',
  'activity.minInvest': 'Inversión Mínima',
  'activity.vipLevel': 'Nivel VIP',
  'activity.avgParticipation': 'Participación Promedio',
  'activity.avgParticipationDesc': 'veces',
  'activity.country': 'Seleccionar País',
  'activity.deliveryTime': 'Tiempo de Publicidad',
  'activity.deliveryTimeDesc': 'días',
  'activity.gender': 'Seleccionar Género',
  'activity.male': 'Masculino',
  'activity.female': 'Femenino',
  'activity.mixed': 'Mixto',
  'activity.age': 'Seleccionar Edad',
  'activity.amount': 'Monto de Compra',
  'activity.back': 'Volver',
  'activity.join': 'Participar Ahora',
  emptyData: 'Sin Datos',
  emptyDataDesc: 'No hay campañas publicitarias participantes',
  completedtlement: 'Expirado',
  preheat: 'Precalentando',
  progress: 'En Progreso',
  settlement: 'Pendiente de Liquidación',
  transfered: 'Transferido',
  completed: 'Completado',
  activityCode: 'Código de Actividad',
  touzAmount: 'Monto de Inversión',
  activityDays: 'Días de Actividad',
  joinTime: 'Hora de Participación',
  playSource: 'Distribución de Fuentes de Reproducción',
  allPlatforms: 'Todas las Plataformas',
  other: 'Otro',
  totalPlayNum: 'Reproducciones Totales',
  incomeSummary: 'Resumen de Ingresos',
  totalPay: 'Tarifas de Derechos de Autor Pagadas',
  totalIncome: 'Ingreso Total',
  copyrightRatio: 'Participación del Titular de Derechos',
  promotionIncome: 'Ingresos por Promoción',
  copyrightIncome: 'Participación de Derechos de Autor',
  playNum: 'Reproducciones',
  buyNum: 'Reproducciones Bajo Demanda',
  incomeRate: 'Proporción de Participación',
  yjIncome: 'Ingreso Estimado',
  paid: 'Pagado',
  timeout: 'Tiempo Agotado',
  transfer: 'Transferir Ahora',
  loading: 'Cargando...',
  loadMore: 'Cargar Más',
  noMore: 'No Hay Más',
  nightTime: 'Período Nocturno',
  morningTime: 'Período Matutino',
  afternoonTime: 'Período Vespertino',
  eveningTime: 'Período Nocturno',
  '_h._tc': 'Cerrar Sesión',
  periodPayment: 'Pago por Período',
  periodPaymentDesc: 'La liquidación se realiza 4 veces al día en 4 períodos, puede pagar las tarifas de derechos de autor por período',

  day: 'día',
  '_dl._hy': 'Bienvenido de nuevo',
  '_dl._cj': 'Crear cuenta',
  '_dl._zmm': 'Restablecer contraseña',
  '_dl._hyDesc': 'Inicia sesión en tu cuenta para seguir explorando contenido excelente',
  '_dl._cjDesc': 'Únete a ReelShortBiz y comienza tu emocionante viaje',
  '_dl._zmmDesc': 'Ingresa tu correo electrónico y te enviaremos un código de verificación para restablecer',
  '_dl._hlgqsp': 'Amplios recursos de películas y videos en HD',
  '_dl._gxhty': 'Algoritmos de recomendación personalizados',
  '_dl._ffddsp': 'Videos cortos variados',
  '_dl._dlzh': 'Iniciar sesión',
  '_dl._sdndyx': 'Ingresa tu correo electrónico y contraseña para continuar',
  '_dl._email': 'Correo electrónico',
  '_dl._qsryx': 'Por favor ingresa tu correo electrónico',
  '_dl._dlmm': 'Contraseña',
  '_dl._qsrmm': 'Por favor ingresa tu contraseña',
  '_dl._wjmm': '¿Olvidaste tu contraseña?',
  '_dl._immdl': 'Iniciar sesión ahora',
  '_dl._hmyzh2': '¿No tienes una cuenta?',
  '_dl._ljzc2': 'Regístrate ahora',
  '_dl._cjzh': 'Crear cuenta',
  '_dl._jswmd': 'Únete a ReelShortBiz y comienza tu emocionante viaje',
  '_zh._qszmm': 'Por favor establece tu contraseña',
  '_zh._qrmm': 'Confirmar contraseña',
  '_zh._qmm': 'Por favor ingresa la contraseña nuevamente',
  '_zc._yqm': 'Código de invitación',
  '_zc._sryqm': 'Por favor ingresa el código de invitación',
  '_dl._yzm': 'Código de verificación',
  '_dl._qsryzm': 'Por favor ingresa el código de verificación',
  '_dl._yjyzh': '¿Ya tienes una cuenta?',
  '_dl._zcbsty2': 'Al registrarte aceptas',
  '_dl._zcbstyDesc': 'Política de privacidad',
  '_dl._newmm': 'Nueva contraseña',
  '_dl._qszxmm': 'Por favor establece una nueva contraseña',
  '_dl._qrmm': 'Confirmar contraseña',
  '_dl._qzcsrmm': 'Por favor ingresa la nueva contraseña nuevamente',
  '_dl._czmm': 'Restablecer contraseña',
  '_dl._xqlmm': '¿Recordaste tu contraseña?',
  '_dl._fhdl': 'Volver al inicio de sesión',
  '_dl._srdllmmbyz': 'Las contraseñas no coinciden',
  '_dl._czcg': 'Contraseña restablecida exitosamente',
  '_h._zc': 'Registrarse',
  // '_ybp._wdsy': 'Mis ganancias',
  '_ybp._jrsy': 'Ganancias de hoy',
  '_ybp._jztr': 'Comparado con ayer',
  '_ybp._bfl': 'Visitas',
  '_ybp._dbl': 'Solicitudes',
  '_ybp._syqs': 'Tendencia de ganancias',
  // '_ybp._jr': 'Hoy',
  '_ybp._t': 'día',
  // '_ybp._dqye': 'Saldo de cuenta',
  '_ybp._djs': 'Pendiente de liquidación',
  '_ybp._zhl': 'Tasa de conversión',
  '_ybp._sjgl': 'Resumen de datos',
  '_ybp._zrsy': 'Ganancias de ayer',
  '_ybp._bysy': 'Ganancias de este mes',
  '_ybp._yysj': 'Datos operativos',
  '_ybp._zr': 'Ayer',
  '_ybp._zjfrs': 'Usuarios de pago totales',
  '_ybp._mtdqje': 'Monto a pagar mañana',
  '_ybp._jsy': 'Ganancias netas',
  '_ybp._bqfy': 'Plan de pago de derechos de autor',
  '_ybp._yzf': 'Pagado',
  '_ybp._qzf': 'Ir a pagar',
  '_ybp._bqfyts': 'Después de pagar los derechos de autor, tus ganancias y derechos serán priorizados',
  '_ybp._syjl': 'Historial de ganancias',
  '_ybp._ckgd': 'Ver más',
  '_ybp._ssdt': 'Actualizaciones en vivo',
  '_ybp._bzzx': 'Centro de ayuda',
  '_ybp._lxkf': 'Contactar soporte',
  '_ybp._zrxz': 'Ganancias de ayer',
  '_ybp._zdsy': 'Ganancias totales',
  '_ybp._qygy': 'Mes pasado',
  '_ybp._jsjl': 'Historial de liquidaciones',
  '_ybp._hzjl': 'Historial de transferencias',
  '_ybp._jfzq': 'hace minutos',
  '_ybp._fzq': 'hace horas',
  '_ybp._djs_mt': 'Monto de liquidación mañana',
  '_yj._rule': 'Reglas de la plataforma',

  '_bq._jjks': 'Empezar ahora',
  '_bq._jxz': 'En curso',
  '_bq._jks': 'Tiempo para empezar',
  '_bq._jjs': 'Tiempo para terminar',
  '_bq._t': 'd',
  '_bq._h': 'h',
  '_bq._m': 'm',
  '_bq._s': 's',
  '_bq._kssj': 'Hora de inicio',
  '_bq._jssj': 'Hora de finalización',
  '_bqq._tzdj': 'Precio unitario',
  '_bqq._hdts': 'Días de actividad',
  '_bqq._vip': 'Nivel VIP',
  '_bqq._rjcy': 'Participación media',
  '_bqq._cs': 'veces',
  '_bqq._ysjd': 'Progreso de ventas',
  '_bqq._ljqg': 'Comprar ahora',
  '_bqq._zbkqg': 'No disponible actualmente',
  '_bqq._jzz': 'Cargando',
  '_bqq._jzgd': 'Cargar más',
  '_bqq._wz': 'No hay más',

  '_sp._gdsj': 'Total {n} episodios',
  '_sy._jl': 'Registro de liquidación pendiente',
  '_ybp._zsy': 'Ingresos totales',
  '_ybp._djsjl': 'Registro de liquidación pendiente',
  '_ybp._bqbm': 'Código',
  '_ybp._je': 'Cantidad',
  '_ybp._sj': 'Hora',
  '_sy._djs': 'Pendiente',
  '_sy._yjs': 'Liquidado',
  '_sy._gdstjl': 'Total {n} registros',
  '_sy._gjd': 'Total {n}',

  '_sp.tgdy':'El importe no puede ser inferior a {a}',
  '_sp.tggy':'El importe no puede ser superior a {a}',

  '_tg._zdyje': 'Monto personalizado'
}
